import { Grid, makeStyles, Typography } from '@material-ui/core';
import { CSSProperties } from '@material-ui/styles';
import { DSScreenMenuCellItem } from 'kiolyn-api';
import React, { FC } from 'react';
import CurrencyFormat from '../Core/CurrencyFormat/CurrencyFormat';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { isNullOrUndefined } from 'util';

const useStyles = makeStyles(theme => ({
  dottedLine: {
    flexGrow: 1,
    margin: theme.spacing(1),
    borderBottomWidth: 1,
    borderBottomColor: theme.palette.text.secondary,
    borderBottomStyle: 'dotted'
  },
  price: {
    minWidth: '4em',
    textAlign: 'right'
  }
}));

interface ItemNameAndPriceProps {
  item: DSScreenMenuCellItem;
  style: CSSProperties;
  showName2?: boolean;
}

const ItemNameAndPrice: FC<ItemNameAndPriceProps> = ({
  item,
  style,
  showName2
}: ItemNameAndPriceProps) => {
  const classes = useStyles();
  const theme = createMuiTheme({
    typography: {
      fontSize: Number(style.fontSize)
    }
  });
  return (
    <Grid container direction="row">
      <ThemeProvider theme={theme}>
        <Typography variant="body1" style={style}>
          {item.name}
        </Typography>
        &nbsp;
        <Typography variant="body1" style={style}>
          {showName2 &&
            !isNullOrUndefined(item.name2) &&
            '(' + item.name2 + ')'}
        </Typography>
        <span className={classes.dottedLine}></span>
        <Typography variant="body1" className={classes.price} style={style}>
          <CurrencyFormat amount={item.price} />
        </Typography>
      </ThemeProvider>
    </Grid>
  );
};

export default ItemNameAndPrice;
